import { t } from '../../services/i18nService';
import questionReader from '../../store/readHelpers/QuestionReader';

const MAX_PROGRESS = 100;

const progressBarSelector = {
    selectProgressPercentage(state) {
        const questionIds = questionReader.getAllQuestionIdsFlat();
        if (!questionIds || questionIds.length === 0) {
            return 0;
        }

        const responseStatus = state.response.status;
        const repliedQuestionsCount = Object.keys(responseStatus)
            .filter(key => questionIds.includes(parseInt(key, 10)))
            .filter(key => !!responseStatus[key]?.atLeastOneInteractionRepliedTo)
            .length;

        return Math.ceil((repliedQuestionsCount / questionIds.length) * MAX_PROGRESS);
    },

    selectProgressBarLabel(currentProgress) {
        return `${t('navigation.progressbar.label')} ${currentProgress}%`;
    },

    mapPropsToProps(state) {
        const currentProgress = this.selectProgressPercentage(state);

        return {
            currentProgress,
            maxProgress: MAX_PROGRESS,
            progressBarLabel: this.selectProgressBarLabel(currentProgress),
        };
    },
};

export default progressBarSelector;
